import { useAbility } from '@cast/shared-ability-data-access';

export const usePermitHpaList = () => {
  const canViewHpaList = useAbility().can('view', 'ClusterWorkloadHpaList');

  return {
    canViewHpaList,
  };
};
